<div class="w-[92px] bg-gray-100 rounded-lg h-10 shadow-inner" [ngClass]="controlCloud">
  <div
    class="w-[92px] rounded-[20px] h-10 overflow-hidden float-left flex flex-col items-center justify-center relative"
  >
    @switch (controlCloud) {
      @case ('init') {
        <div class="flex items-center justify-center h-[40px]">
          <div class="tree-balls"></div>
        </div>
      }
      @case ('saving') {
        <div class="flex flex-col items-center h-[40px] justify-end">
          <div class="tree-balls mb-[4px] animation-tree-balls"></div>
          <div class="text-xs mb-[8px]">Salvando</div>
        </div>
      }
      @case ('error') {
        <div class="icon-erro text-error show"></div>
        <div class="text-xs show">Falha!</div>
      }
      @default {
        @if (savedFinish) {
          <div class="text-xs transition duration-200 ease-in-out">Salvo!</div>
        }
      }
    }
  </div>
</div>
